import React, { useEffect, useRef, useState } from 'react'
import ClientsStyle from './Clients'
import Button from '../../components/Button'
import api, { customFuncsApi } from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal, SuccessModal } from '../../components/Modal'
import UpdateUser from './UpdateUser'
import ClipLoader from 'react-spinners/ClipLoader'
import ScoreCreateUser from '../../components/Modal/ScoreUserCreate'
import { Empty, Button as AntButton, AutoComplete, Tag, Pagination } from 'antd'
import formatPhoneNumber from '../../helpers/PhoneWithSpaces'
import { useTranslation } from 'react-i18next'
import useEnterKey from '../../hooks/useEnterKey'
import {
	ArrowDownOutlined,
	ArrowUpOutlined,
	EyeFilled,
} from '@ant-design/icons'
import { useDebounce } from 'use-debounce'

const ScoringClients = () => {
	const errorRef = useRef()
	const updateRef = useRef()
	const createUserRef = useRef()
	const succesCreateUserRef = useRef()
	const { t } = useTranslation()

	const [sortConfig, setSortConfig] = useState({
		column: null,
		direction: null,
	})

	const [isLoading, setIsLoading] = useState(false)
	const [isBusinessPartnersLoading, setIsBusinessPartnersLoading] =
		useState(false)
	const [clientName, setClientName] = useState('')
	const [clientPhone, setClientPhone] = useState('')
	const [clientStreet, setClientStreet] = useState('')
	const [userFields, setUserFields] = useState([])
	const [frozenFor, setFrozenFor] = useState('')

	const [clientCode, setClientCode] = useState('')

	const [page, setPage] = useState(0)
	const [currentPage, setCurrentPage] = useState(0)
	const [totalPage, setTotalPage] = useState(0)

	const [data, setData] = useState({
		data: [],
	})
	const [debouncedClientName] = useDebounce(clientName, 500)
	const [clients, setClients] = useState([])

	const search = (sortConfig) => {
		setIsLoading(true)
		let url = `xsSql/getClientsForScoring?${sortConfig.direction !== null ? `orderBy=[{"name": "${sortConfig.column}", "type" : "${sortConfig.direction}"}]&` : ``}$skip=${currentPage * 40}`

		if (frozenFor) {
			url = `xsSql/getClientsForScoring?frozenFor=${frozenFor ? frozenFor : undefined}&${sortConfig.direction !== null ? `orderBy=[{"name": "${sortConfig.column}", "type" : "${sortConfig.direction}"}]&` : ``}$skip=${currentPage * 40}`
		}

		const formattedName = clientName.includes("'")
			? clientName.replace(/'/g, "''")
			: clientName

		if (formattedName.length >= 1) url += `&CardName='${formattedName}'`
		if (clientCode.length >= 1) url += `&CardCode='${clientCode}'`
		if (clientPhone.length >= 1) url += `&U_Telephone='${clientPhone}'`
		if (clientStreet.length >= 1) url += `&StreetNo='${clientStreet}'`

		customFuncsApi
			.get(url, {
				headers: {
					Prefer: `odata.maxpagesize=40`,
				},
			})
			.then((res) => {
				let resData = res.data.value

				if (clientName || clientCode) {
					resData =
						res.data.value.length > 1 ? [res.data.value[0]] : res.data.value
				}

				setData({
					data: [...resData],
				})

				setTotalPage(parseInt([...resData][0].DocCount / 40) || 1)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	useEffect(() => {
		setIsBusinessPartnersLoading(true)
		const url = `xsSql/getBusinessPartners?CardName=${debouncedClientName}`
		customFuncsApi
			.get(url, {
				headers: { Prefer: `odata.maxpagesize=100000` },
			})
			.then((res) => setClients(res.data.value))
			.catch((err) =>
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				),
			)
			.finally(() => setIsBusinessPartnersLoading(false))
	}, [debouncedClientName])

	useEffect(() => {
		search(sortConfig)
		userFieldsFn()
	}, [page, sortConfig, frozenFor, currentPage])

	const viewItem = (v) => {
		updateRef.current?.open(v)
	}

	const handleCreateUser = () => {
		createUserRef.current?.open()
	}

	const userFieldsFn = () => {
		api
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OINV'",
					$select: 'Name,ValidValuesMD,TableName',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const handleSort = (column) => {
		let direction = 'ASC'
		if (sortConfig.column === column && sortConfig.direction === 'ASC') {
			direction = 'DESC'
		} else if (
			sortConfig.column === column &&
			sortConfig.direction === 'DESC'
		) {
			direction = null
		}
		setSortConfig({ column, direction })
	}

	const UsersInvoice = (v, e) => {
		e.stopPropagation()
		const url = `/users-invoices?CardCode=${v}`
		window.open(url, '_blank')
	}

	useEnterKey(() => search(sortConfig))

	return (
		<Layout>
			<ClientsStyle>
				<div className="container minWidthContainer">
					<p className="productTitle ">{t('clients')}</p>
					<div className="flex items-center justify-between flex-col sm:flex-row mt-8 mb-8 gap-5">
						<div className="flex items-center gap-5 flex-col sm:flex-row w-full">
							<AutoComplete
								options={clients?.map((item) => ({
									value: `${item.CardName} ,/ ${item.CardCode}`,
									label: (
										<div className="flex items-center justify-between">
											<span>{item.CardName}</span>
											<Tag color="blue">{item.CardCode}</Tag>
										</div>
									),
									cardName: item.CardName,
									cardCode: item.CardCode,
								}))}
								isLoading={isBusinessPartnersLoading}
								value={clientName}
								placeholder={t('clients')}
								onSelect={(value) => {
									const [cardName, cardCode] = value.split(' ,/ ')
									setClientCode(cardCode)
									setClientName(cardName)
								}}
								className="w-full h-[40px]"
								onChange={(value) => setClientName(value)}
								showSearch
							/>

							<input
								type="text"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								placeholder={t('clientPhone')}
								defaultValue={clientPhone}
								onChange={(v) => setClientPhone(v.target.value)}
							/>

							<input
								type="text"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								placeholder={t('clientStreet')}
								defaultValue={clientStreet}
								onChange={(v) => setClientStreet(v.target.value)}
							/>
							<select
								placeholder={t('clients')}
								className='border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								onChange={(e) => setFrozenFor(e.target.value)}
							>
								<option value="">{t('clients')}</option>
								<option value="N">{t('active')}</option>
								<option value="Y">{t('inactive')}</option>
							</select>

							<AntButton
								onClick={() => {
									search(sortConfig)
									setPage(0)
									setCurrentPage(0)
								}}
								className="w-full h-10 bg-[#0A4D68] text-white p-2 rounded-md  sm:w-[170px]"
								loading={isLoading}
							>
								{t('search')}
							</AntButton>
						</div>
						<AntButton
							className="w-full h-10 bg-[#0A4D68] text-white p-2 rounded-md  sm:w-[170px]"
							onClick={handleCreateUser}
						>
							{t('add')}
						</AntButton>
					</div>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className=" overflow-auto mb-8">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50">
										<tr>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('CardCode')}
											>
												<div className="flex items-center gap-2">
													<span>{t('clientCode')} </span>
													<div>
														{sortConfig.column === 'CardCode' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined className="" />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined className="" />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('CardName')}
											>
												<div className="flex items-center gap-2">
													<span>{t('clientName')}</span>
													<div>
														{sortConfig.column === 'CardName' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined className="" />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined className="" />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th>{t('bornDate')}</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('U_Telephone')}
											>
												<div className="flex items-center gap-2">
													<span>{t('phone')}</span>
													<div>
														{sortConfig.column === 'U_Telephone' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined className="" />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined className="" />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('U_PS')}
											>
												<div className="flex items-center gap-2">
													<span>{t('passport')}</span>
													<div>
														{sortConfig.column === 'U_PS' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined className="" />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined className="" />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('LastInvoice.U_Score.Name')}
											>
												<div className="flex items-center gap-2">
													<span>{t('status')}</span>
													<div>
														{sortConfig.column ===
														'LastInvoice.U_Score.Name' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined className="" />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined className="" />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() =>
													handleSort('LastInvoice.LastComment.U_Text')
												}
											>
												<div className="flex items-center gap-2">
													<span>{t('lastComment')}</span>
													<div>
														{sortConfig.column ===
														'LastInvoice.LastComment.U_Text' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined className="" />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined className="" />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('U_MIB')}
											>
												<div className="flex items-center gap-2">
													<span>{t('region2')}</span>
													<div>
														{sortConfig.column === 'U_MIB' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined className="" />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined className="" />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('StreetNo')}
											>
												<div className="flex items-center gap-2">
													<span>{t('street')}</span>
													<div>
														{sortConfig.column === 'StreetNo' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined className="" />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined className="" />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th scope="col" className="px-6 py-4">
												{t('status')}
											</th>
											<th scope="col" className="px-6 py-4">
												{t('created_date')}
											</th>
											<th scope="col" className="px-6 py-4">
												{t('created_by')}
											</th>
											<th scope="col" className="px-6 py-4">
												{t('historyPurchase')}
											</th>

											<th scope="col" className="px-6 py-4">
												{t('see_button')}
											</th>
										</tr>
									</thead>
									<tbody>
										{data.data.length > 0 ? (
											data.data.map((v, i) => {
												return (
													<tr
														className="bg-white border-b hover:bg-gray-50"
														key={i}
													>
														<td className="px-6 py-4 font-medium text-gray-900">
															{get(v, 'CardCode', '') || '—'}
														</td>
														<td className="px-6 py-4">
															{get(v, 'CardName', '') || '—'}
														</td>
														<td className="px-6 py-4">
															{get(v, 'U_age_data', '') || '—'}
														</td>
														<td className="px-6 py-4">
															{formatPhoneNumber(get(v, 'U_Telephone', '')) ||
																'—'}
														</td>
														<td className="px-6 py-4">
															{get(v, 'U_PS', '') || '—'}
														</td>

														<td className="px-6 py-4">
															{get(v, 'LastInvoice.U_Score.Name', '') || '—'}
														</td>
														<td className="px-6 py-4">
															{get(v, 'LastInvoice.LastComment.U_Text', '') ||
																'—'}
														</td>
														<td className="px-6 py-4">
															{get(v, 'ADDRESS_CITY.Name', '') || '—'}
														</td>
														<td className="px-6 py-4">
															{get(v, 'StreetNo', '')
																? get(v, 'StreetNo', '')
																: '—'}
															<br />
															{get(v, 'Building', '')
																? get(v, 'Building', '')
																: '—'}
														</td>
														{/* <td className="px-6 py-4">
															{get(v, 'frozenFor', '') === 'N' &&
															get(v, 'validFor', '') === 'Y'
																? t('active')
																: get(v, 'frozenFor', '') === 'Y' &&
																	  get(v, 'validFor', '') === 'N'
																	? t('inactive')
																	: '—'}
														</td> */}
														<td className="px-6 py-4">
															{get(v, 'frozenFor', '') === 'Y'
																? t('inactive')
																: get(v, 'frozenFor', '') === 'N'
																	? t('active')
																	: '--'}
														</td>
														<td className="px-6 py-4">
															{get(v, 'CreateDate', '') || 'Bekap'} <br />
															{get(v, 'CreateTime', ' ') || 'Bekap'}
														</td>
														<td className="px-6 py-4">
															{get(v, 'U_Created.firstName', '') || '—'}{' '}
															{get(v, 'U_Created.lastName', '') || '—'}
														</td>
														<td className="px-6 py-4">
															<button
																className={
																	'bg-[#0A4D68] w-[130px] h-[40px] text-white rounded-xl'
																}
																onClick={(e) => UsersInvoice(v.CardCode, e)}
															>
																{t('historyPurchase') || '—'}
															</button>
														</td>
														<td className="px-6 py-4">
															<Button
																className="btn"
																onClick={() => viewItem(v)}
															>
																<EyeFilled />
															</Button>
														</td>
													</tr>
												)
											})
										) : (
											<tr>
												<td colSpan="10">
													<Empty
														description={t('noInfo')}
														image={Empty.PRESENTED_IMAGE_SIMPLE}
													/>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
							<Pagination
								showSizeChanger={false}
								current={currentPage + 1}
								pageSize={1}
								total={totalPage}
								itemBgColor={'#1890ff'}
								itemHoverBgColor={'#40a9ff'}
								showQuickJumper
								onChange={(page) => {
									console.log(page)
									if (totalPage >= page) {
										setCurrentPage(page - 1)
									} else {
										alert(
											`${t('noOtherInfo')} ${t('totalPages')} : ${parseInt(totalPage)} `,
										)
									}
								}}
							/>
						</>
					)}
				</div>
			</ClientsStyle>
			<ErrorModal getRef={(r) => (errorRef.current = r)} />
			<UpdateUser
				getRef={(ref) => (updateRef.current = ref)}
				onUpdated={() => search(sortConfig)}
			/>
			<ScoreCreateUser
				getRef={(ref) => (createUserRef.current = ref)}
				onConfirm={() => succesCreateUserRef.current?.open(t('sucClient'))}
				onClose={() => {
					succesCreateUserRef.current?.close()
				}}
				onUpdated={() => search(sortConfig)}
			/>
			<SuccessModal
				getRef={(r) => {
					succesCreateUserRef.current = r
				}}
			/>
		</Layout>
	)
}

export default ScoringClients
